// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('div')`
  color: ${props => props.theme.tooltip.iconColor};
  cursor: pointer;
  display: inline-block;
  height: ${props => props.iconSize};
  width: ${props => props.iconSize};
`;
